import { SegmentedControl, type SegmentedControlProps } from '@mantine/core';
import type { CSSProperties } from 'react';

import styles from './ColoredSegmentedControl.module.css';

interface ColoredSegmentedControlProps extends Omit<
  SegmentedControlProps,
  'style'
> {
  /**
   * Runtime color for the active-segment indicator (e.g. a priority or
   * severity palette value). Injected as the `--csc-color` CSS custom
   * property; the active label text flips to white.
   */
  color: string;
}

/**
 * `SegmentedControl` whose active segment is tinted with a runtime color
 * stamped in via the `--csc-color` custom property (F-N1 injection pattern).
 * Used for enum pickers that carry a domain palette — task priority,
 * obstruction severity, etc.
 */
export const ColoredSegmentedControl = ({
  color,
  className,
  ...rest
}: ColoredSegmentedControlProps) => (
  <SegmentedControl
    {...rest}
    className={className ? `${styles.root} ${className}` : styles.root}
    style={{ '--csc-color': color } as CSSProperties}
  />
);
